export enum EntityType {
  Case = "C",
  SubCase = "S",
  Creditor = "CRE",
  Ar = "A",
}

export const EntityTypeOptions = [
  { label: "Case", value: EntityType.Case },
  { label: "SubCase", value: EntityType.SubCase },
  { label: "Creditor", value: EntityType.Creditor },
  { label: "Ar", value: EntityType.Ar },
];
export const ROUTE_SEGMENT: Readonly<Record<EntityType, string>> = {
  [EntityType.Case]: "case",
  [EntityType.SubCase]: "case",
  [EntityType.Ar]: "ar",
  [EntityType.Creditor]: "creditor",
};

export const ROUTE_LOOKUP: Readonly<Record<string, string>> =
  EntityTypeOptions.reduce(
    (acc, { label, value }) => {
      const segment = ROUTE_SEGMENT[value];
      acc[value.toLowerCase()] = segment;
      acc[label.toLowerCase()] = segment;
      return acc;
    },
    {} as Record<string, string>,
  );
export enum StorageType {
  BlobStorage = "BlobStorage",
}

export const DEFAULT_PREVIEW_TEXT = "No Preview Available";

export enum FormField {
  BulkCreditorName = "bulkCreditorName",
  BulkDebtorName = "bulkDebtorName",
  BulkAssignTo = "bulkAssignTo",
  BulkCategory = "bulkCategory",
  BulkEntityType = "bulkEntityType",
}

export const InitialFormValues: { [k in FormField]: string } = {
  [FormField.BulkCreditorName]: "",
  [FormField.BulkDebtorName]: "",
  [FormField.BulkAssignTo]: "",
  [FormField.BulkCategory]: "",
  [FormField.BulkEntityType]: "",
};

export type DocRow = {
  key: string;
  documentName: string;
  assignTo?: string;
  category?: string;
  debtorName?: string;
  creditorName?: string;
  checked?: boolean;
  canConfirm?: boolean;
  loading?: boolean;
  file?: File | null;
  entityType?: string;
  errorMessage?: string;
  entityId?: string;
  mapped?: boolean;
};
export type DocumentCategoryItem = {
  documentCategory: string;
};

export type SelectOption = {
  value: string;
  label: string;
};
export type SplitRowItem = {
  key: string;
  documentName: string;
  assignTo: string;
  category: string;
  debtorName: string;
  creditorName: string;
  checked: boolean;
  file: File;
};

export type SplitDisplayFileItem = {
  key: string;
  documentName: string;
  assignTo: string;
  creditorName: string;
  debtorName: string;
  file: File;
  pages: string;
  size: string;
};

export type SplitListsOutput = {
  rows: SplitRowItem[];
  fileList: SplitDisplayFileItem[];
};
export type DocumentReference = {
  documentId: number;
};

export type MappedDocument = DocumentReference & {
  key: React.Key;
};
